import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import MultiSelectField from '../MultiSelectField/MultiSelectField';

import './PaymentMethodsField.css';

const PaymentMethodsField = ({ name, eshop, pos, placeholder }) => {
    const { t } = useTranslation();

    const methods = eshop ?
        Utils.eshopPaymentMethods() : (
            pos ? Utils.posPaymentMethods() : Utils.paymentMethods()
        );
    const options = methods.map(m => {
        return {
            key: m,
            text: t(`payment_methods.${m}`),
            value: m
        };
    });

    return <MultiSelectField
        name={ name }
        options={ options }
        placeholder={ placeholder }
    />
}

export default PaymentMethodsField;
